export const widgetClassPerCol = [
    "",
    "ant-col-xs-24 ant-col-sm-24 ant-col-lg-24",
    "ant-col-xs-24 ant-col-sm-12 ant-col-lg-12",
    "ant-col-xs-24 ant-col-sm-24 ant-col-lg-12 ant-col-xl-8",
    "ant-col-xs-24 ant-col-sm-12 ant-col-lg-6"
  ];